import type { AdminMessage } from '@/lib/api/admin-feedback'

export function formatAdminSenderLabel(
  msg: Pick<AdminMessage, 'sender_display_name' | 'sender_email'>,
): string {
  const name = msg.sender_display_name || msg.sender_email?.split('@')[0]
  return name ? `${name} (Admin)` : 'Admin'
}
